import Vue from 'vue';
import VueRouter from 'vue-router';

// indent revamp modules route imports
import Indent from '@/modules-v2/indent/router';
import eximRoute from '@/modules-v2/exim/exim_route';

import store from '../store';

import Auth from './auth';
import Home from './home';
import Order from './order';
import Mdm from './mdm';
import Setting from './setting';
import Dashboard from './dashboard';
import Invoice from './invoice';
import PaymentsV2 from './pay-v2';
import ErrorPage from './error';
import Optima from './optima';
import Dispatch from './dispatch';
import Map from './map';
import Freight from './freight';
import Admin from './admin';
import Wallet from './wallet';
import Reports from './reports';
import Redirect from './redirect';
import Track from './track';
import Eximlist from './eximlist';
import integration from './integration';
import MdmV2 from './mdm-v2';
import Pack from './pack';
import ControlTower from './control-tower';
import OrderHub from './order-hub';
import Fap from './fap';
import DefaultRedirect from './defaultRedirect';
import Planning from './planning';
import PaySettlement from './pay-settlement';
import MenuNavigator from './menuNavigator';
import ShipmentWorkflow from './shipment-workflow';
import InsightTower from './insight-tower';
import RateLookUp from './rateLookUp';
import RIQ from './riq';

Vue.use(VueRouter);

const routes = [...Auth, ...Dashboard, ...Home, ...Pack, ...ControlTower, ...OrderHub,
  ...DefaultRedirect,
  ...Order, ...Mdm, ...Setting, ...Invoice, ...PaymentsV2, ...ErrorPage, ...Optima, ...Fap,
  ...Dispatch, ...Freight, ...Map, ...Wallet, ...Admin, ...Redirect, ...Reports, ...Track,
  ...MdmV2, ...Indent, ...Eximlist, ...integration, ...eximRoute, ...Planning,
  ...PaySettlement, ...MenuNavigator, ...InsightTower, ...RateLookUp, ...RIQ, ...ShipmentWorkflow];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() { return { x: 0, y: 0 }; },
});

router.beforeEach((to, from, next) => {
  if (to.query.tsmToken) {
    localStorage.setItem('tsm-user-token', to.query.tsmToken);
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('tsm-user-token')) {
      window.location = `${window.location.origin}/login`;
    } else {
      const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
      if (nearestWithTitle) {
        document.title = `${nearestWithTitle.meta.title} | Pando Enterprise`;
        const permissionName = nearestWithTitle.meta.permission || null;
        if (permissionName) {
          const user = store.getters['app/currentUser'];
          const roles = (user && user.permissions_list) || [];
          if (roles.length && roles.indexOf(permissionName) === -1) {
            window.location = `${window.location.origin}/login`;
          }
        }
      }
      next();
    }
  } else {
    if (!to.matched.length) {
      next({ name: 'NotFound' });
    } else {
      const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
      if (nearestWithTitle) {
        document.title = `${nearestWithTitle.meta.title} | Pando Enterprise`;
      }
    }
    next();
  }
});

export default router;
